<template>
    <span class="inv-span">{{invSpan}}</span>&nbsp;
    <copyButton @click="copyShareUrl" />

    <el-popover placement="bottom" :width="174" trigger="hover" v-if="true === showQRCode">
        <template #reference>
            <qrcodeButton />
        </template>
        <qrcodeComponents v-if="null != invUrl" :url="invUrl" :width="150" :height="150" />
    </el-popover>
</template>

<script setup>
    import {getCurrentInstance} from "vue";
    import qrcodeComponents from "@/components/shopopee/common/qrcodeComponents"
    import qrcodeButton from "@/components/shopopee/button/qrcodeButton"
    import copyButton from "@/components/shopopee/button/copyButton"
    import { useUserinfo } from '@/stores/userinfo'
    import {toRef, ref, onMounted} from "vue";
    import copy from "clipboard-copy";
    import util from "@/util/util";

    const props = defineProps(["showQRCode"])
    const { proxy } = getCurrentInstance()

    const userInfoRef = toRef(useUserinfo())

    const invSpan = ref("")

    const invUrl = ref(null)

    function getInvSpan() {
        invSpan.value = `${userInfoRef.value.companyId}A${userInfoRef.value.id}`

        invUrl.value = `${proxy.$ShopopeeUrl}account_page?operation=signup&promotion=${invSpan.value}`
    }

    function copyShareUrl(){
        copy(invUrl.value)
        util.alertSuccess("已將內容複製到剪貼板")
    }

    onMounted(() => {
        getInvSpan()
    })
</script>

<style scoped>
    .inv-span {
        font-size: 1.2em;
        font-weight: 600;
    }
</style>